export const environment = {
    production: false,
    apiUrl: 'https://hapi.hotsys.com.br/api'
  };